import React from "react";
import { func, bool, string } from "prop-types";
import { Modal, Row, Col, Button, Dropdown } from "react-bootstrap";
import criteriaLogo from "../../../resources/images/CriteriaLogo_Small.png";

const RegionSelectModal = ({
  showRegionSelectModal,
  handleHideRegionSelectModal,
  handleRegionSelectOnChange,
  region,
}) => {
  // style variable
  const dropdownItemStyle = { paddingLeft: "12px" };

  const handleRegionSelectContinue = (e) => {
    e.preventDefault(e);

    const url =
      region === "Asia-Pacific" || region === "Southern Africa"
        ? "https://www.criteriacorp.com.au/free-trial"
        : "https://www.criteriacorp.com/free-trial";

    window.location.href = url;
  };

  return (
    <Modal
      centered
      show={showRegionSelectModal}
      onHide={handleHideRegionSelectModal}
    >
      <Modal.Header closeButton style={{ borderBottom: "none" }}></Modal.Header>
      <Modal.Body className="mx-auto pt-0">
        <Row>
          <Col className="text-center">
            <div className="mb-3">
              <img
                src={criteriaLogo}
                alt="criteria logo"
                width="40px"
                height="40px"
              />
            </div>
            <h3 style={{ fontSize: "20px" }}>Try Criteria for Free</h3>
            <p
              className="mb-4"
              style={{ color: "#828283", fontSize: "14px" }}
            >{`Let's get started! First, please select your country`}</p>
            <Dropdown onSelect={handleRegionSelectOnChange} className="mb-4">
              <div>
                <Dropdown.Toggle
                  id="countryDropdownToggle"
                  className="text-left"
                  style={{
                    minWidth: "300px",
                    backgroundColor: "#fff",
                    color: "#000",
                    borderColor: "#b1b3b3",
                  }}
                >
                  {region}
                </Dropdown.Toggle>
              </div>
              <Dropdown.Menu style={{ minWidth: "300px" }}>
                <Dropdown.Item eventKey="asiaPacific" style={dropdownItemStyle}>
                  Asia-Pacific
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="centralSouthAmerica"
                  style={dropdownItemStyle}
                >
                  Central & South America
                </Dropdown.Item>
                <Dropdown.Item eventKey="europeUK" style={dropdownItemStyle}>
                  Europe & the UK
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="middleEastNorthernAfrica"
                  style={dropdownItemStyle}
                >
                  Middle-east & Northern Africa
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="southernAfrica"
                  style={dropdownItemStyle}
                >
                  Southern Africa
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="usNorthAmerica"
                  style={dropdownItemStyle}
                >
                  US & North America
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Button
              variant="primary"
              id="countryDropdownContinueBtn"
              type="button"
              onClick={handleRegionSelectContinue}
            >
              Continue
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

RegionSelectModal.propTypes = {
  showRegionSelectModal: bool,
  handleHideRegionSelectModal: func.isRequired,
  handleRegionSelectOnChange: func.isRequired,
  region: string,
};

export default RegionSelectModal;
